import _ from "lodash";

import { IAction } from "redux/store/model";

import {
  IChangeSubcategorySuccessActionCreator,
  IFetchCreditTransactionsFailureAction,
  IFetchCreditTransactionsSuccessAction,
  ISetCustomerAttributeActionCreator,
  ISetCustomerLocationsActionCreator,
  ISetCustomersLegendActionCreator,
} from "./actionCreator";
import * as types from "./actionTypes";
import initialState, { ICustomersState } from "./initialState";
import { prepareLegendForFE } from "./utils";

export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case types.SET_CUSTOMERS_ATTRIBUTE: {
      const { attributeTag, attributeData } =
        action as ISetCustomerAttributeActionCreator;

      const customerLocations = (state as ICustomersState).customerLocations;

      _.forEach(attributeData, (ad) => {
        const customer = customerLocations?.find((c) => c._id === ad._id);
        const value = ad[attributeTag];

        if (customer) {
          _.set(customer, attributeTag, value);
        }
      });

      return {
        ...state,
        customerLocations,
      };
    }

    case types.CHANGE_SUBCATEGORY_SELECTED_SUCCESS: {
      const { subcategory } = action as IChangeSubcategorySuccessActionCreator;
      return {
        ...state,
        subCategorySelected: subcategory,
      };
    }
    case types.SET_CUSTOMERS_LEGEND: {
      const { legend, lang, legendFilterKey } =
        action as ISetCustomersLegendActionCreator;
      legend.lastUpdated = new Date();
      prepareLegendForFE(legend, lang);
      return {
        ...state,
        allLegends: { ...state.allLegends, [legendFilterKey]: legend },
      };
    }
    case types.CLEAR_LEGENDS_CACHE: {
      return {
        ...state,
        allLegends: {},
      };
    }
    case types.SET_CUSTOMER_LOCATIONS: {
      const { customerLocations, hasMoreCustomers } =
        action as ISetCustomerLocationsActionCreator;
      return {
        ...state,
        customerLocations,
        hasMoreCustomers,
      };
    }
    case types.CLEAR_DATA:
      return initialState;
    case types.FETCH_CREDIT_TRANSACTIONS_BEGIN:
      return {
        ...state,
        credit: {
          ...state.credit,
          isLoading: true,
          error: null,
        },
      };
    case types.FETCH_CREDIT_TRANSACTIONS_SUCCESS: {
      const successAction = action as IFetchCreditTransactionsSuccessAction;
      return {
        ...state,
        credit: {
          ...state.credit,
          isLoading: false,
          transactions: successAction.payload.append
            ? [
                ...state.credit.transactions,
                ...successAction.payload.transactions,
              ]
            : successAction.payload.transactions,
          count: successAction.payload.count,
        },
      };
    }
    case types.FETCH_CREDIT_TRANSACTIONS_FAILURE: {
      const failureAction = action as IFetchCreditTransactionsFailureAction;
      return {
        ...state,
        credit: {
          ...state.credit,
          isLoading: false,
          error: failureAction.payload.error,
        },
      };
    }
    default:
      return state;
  }
}
